/* eslint-disable */
export const initialStatsSummary = [
	{
		label: 'Total',
		value: 16140,
		icon: 'Hash',
	},
	{
		label: 'Passed',
		value: 16140,
		icon: 'CheckCircle',
	},
	{
		label: 'Overridden',
		value: 16140,
		icon: 'RefreshCcw',
	},
	{
		label: 'Failure',
		value: 16140,
		icon: 'XCircle',
	},
];

export const initialTabs = [
	{ key: 'sourcing', label: 'Sourcing', active: true },
	{ key: 'production', label: 'Production', active: false },
	{
		key: 'distribution',
		label: 'Distribution',
		active: false,
		disabled: true,
	},
];

export const initialAnalysisTabs = [
	{
		key: 'quality',
		label: 'Quality Analysis',
		icon: 'Settings',
		active: true,
	},
	{
		key: 'failure',
		label: 'Failure Analysis',
		icon: 'Settings',
		active: false,
	},
	{
		key: 'statistical',
		label: 'Statistical Analysis',
		icon: 'Settings',
		active: false,
	},
];

export const initialQCTypes = [
	{ key: 'sampling', label: 'Sampling QC', active: true },
	{ key: 'inwarding', label: '100% Inwarding', active: false },
];

export const initialConfigTypes = [
	{ key: 'time', label: 'Time', active: true },
	{ key: 'product', label: 'Product', active: false },
	{ key: 'geography', label: 'Geography', active: false },
];

export const initialTimeRangesDropdown = [
	{ key: 'year', label: 'Month wise', active: false },
	{ key: 'quarter', label: 'Week wise', active: true },
	{ key: 'month', label: 'Day wise', active: false },
];
export const productWiseDropdown = [
	{ key: 'brand', label: 'Category Wise', active: true },
	{ key: 'category', label: 'Sub Category Wise', active: false },
	{ key: 'subCategory', label: 'Product Wise', active: false },
];
export const geographyWiseDropdown = [
	{ key: 'brand', label: 'Region wise', active: true },
	{ key: 'region', label: 'City wise', active: false },
	{ key: 'city', label: 'store wise', active: false },
];

export const initialFailureParameters = [
	{ key: 'all', label: 'All parameters', active: true },
];

export const machineParameters = [
	{
		key: 'temperature',
		label: 'Temperature',
		category: 'AI supervisor checks',
		active: false,
	},
	{
		key: 'weight',
		label: 'Weight',
		category: 'AI supervisor checks',
		active: false,
	},
	{
		key: 'visual',
		label: 'Visual Quality',
		category: 'AI supervisor checks',
		active: false,
	},
]

export const initialAnalysisData = {
	chartData: {
		labels: [],
		labelIds: [],
		datasets: [],
	},
	statsData: {
	},
};


export const initialStatisticalAnalysisData = {
	lineData: {},
	metricData: [],
	statsBoxData: [],
};


const tabVariants = {
	enter: {
		opacity: 0,
		y: 20,
	},
	center: {
		opacity: 1,
		y: 0,
	},
	exit: {
		opacity: 0,
		y: -20,
	},
};

const fadeVariants = {
	hidden: {
		opacity: 0,
		y: 10,
	},
	visible: {
		opacity: 1,
		y: 0,
	},
};

const timeFrameList = ['Daily','Week', 'Month', 'Custom'];


export { tabVariants, fadeVariants, timeFrameList };
